<template>
	<section>
		<!--工具条-->
		<div class="pa_main_search_inner">
			<el-form :inline="true" @submit.native.prevent>
				<el-form-item>
					<div class="search_ipt_box con_box p_tb5">
						<el-input
							class="no_border"
							prefix-icon="el-icon-search"
							placeholder="输入会员手机号或昵称"
							v-model.trim="user_search"
						></el-input>
					</div>
				</el-form-item>
				<el-form-item>
					<el-button @click="searchUser" class="pa_btn" size="max" type="FF7">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button class="pa_btn" size="max" type="FF7" @click="newUserDialog = true">新增会员</el-button>
				</el-form-item>
				<!--<el-form-item>-->
					<!--<el-button @click="exportData" class="pa_btn" size="max" type="FFF">导出</el-button>-->
				<!--</el-form-item>-->

			</el-form>
			<el-form :inline="true">
				<el-form-item v-for="(item,index) in userGroupList" :key="index">
					<el-button @click="selectGroupItem(item)" :class="user_group_id == item.group_id?'on':''" class="pa_btn" size="small" type="FFF">{{item.group_name}}</el-button>
				</el-form-item>
			</el-form>
		</div>
		<!--列表-->
		<div class="pa_table_box" v-loading="loading">
			<el-table
				:data="tableData"
				style="width: 100%;font-size: 12px"
				@sort-change="sortChange"
			>
				<!-- <el-table-column prop="user" width="100" label="全选">
					<template slot-scope="scope">
						<el-checkbox-group  v-model="checkedList" @change="checkedListChange">
							<el-checkbox :value="scope.rowuser_id"></el-checkbox>
						</el-checkbox-group>
					</template>
				</el-table-column> -->
				<el-table-column prop="user" width="200" label="会员信息">
					<template slot-scope="{row}">
						<div class="pa_user_list_info_box">
							<img class="img"
								:class="row.user_avatar ? '' : 'default_img'"
								:src="(row.user_avatar && (row.user_avatar).indexOf('https') == -1) ?
									`${$config.img_url}${row.user_avatar}` : row.user_avatar"
							>
							<div class="text">
								<span>{{row.user_nickname}}</span>
								<span class="numbers">编号:{{row.card_no ? row.card_no : '--'}}</span>
							</div>
						</div>
					</template>
				</el-table-column>

				<el-table-column width="150" prop="mobile" label="手机号码"></el-table-column>
				<!-- <el-table-column width="100" prop="card_no" label="会员卡号"></el-table-column> -->
				<el-table-column width="150" prop="integral" sortable label="会员级别">
					<template slot-scope="{ row }">
						<div>{{row.group_name}}</div>
					</template>
				</el-table-column>
				<el-table-column width="150" prop="available_balance" sortable label="会员资产">

					<template slot-scope="{ row }">
						<div>余额:{{row.available_balance}}</div>
						<div>成长值:{{row.integral}}</div>
					</template>
				</el-table-column>
				<el-table-column width="150" prop="count_amount" sortable label="消费情况">
					<template slot-scope="{ row }">
						<div>累计消费:{{row.count_amount}}</div>
						<div>最近消费:{{row.last_order_amount}}</div>
					</template>
				</el-table-column>
				<el-table-column prop="merchant_name" label="归属门店"></el-table-column>
				<el-table-column label="宠物档案">
					<template slot-scope="scope">
						<el-button @click="petDataList(scope.row.user_id)" size="text" class="list_button">宠物列表</el-button>
					</template>
				</el-table-column>
				<el-table-column width="180" prop="updated_at" sortable label="最后到店时间"></el-table-column>
				<el-table-column width="180" prop="zip" label="操作">
					<template slot-scope="{ row }">
						<el-button @click="userInfo(row.user_id)" size="text"  class="list_button">查看详情</el-button>
						<el-button @click="userDel(row.user_id)" size="text"  class="list_button" v-if="isShowDel(row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<pagination :total="tableForm.total" :page.sync="tableForm.page" :limit.sync="tableForm.limit" @pagination="initData"/>
		</div>
		<alertPop :status="exportDialog" size="mini" :conText="exportContent" type="2" @clock="popCloseTap"></alertPop>
		<addUser :status="newUserDialog" size="small"  @add="addUserTap"></addUser>
		<petList :status="petListDialog" size="max" :uid="current_uid" @add="petListTap"></petList>
	</section>
</template>
<script>
	import alertPop from '@/components/common/alertPop.vue'
	import addUser from '@/components/common/addUser.vue'
	import petList from '@/components/common/petList.vue'
	export default {
		components:{
			alertPop,
			addUser,
			petList,
		},
		data(){
			return{
			    user_group_id:'0',
			    userGroupList:[],
				loading: false,
				current_uid:'',
				user_search:'',
				search_goods:'',
				sortIndex:0,
				tableData: [],
				tableForm: {
					total: 0,
					page: 1,
					limit: 10
				},
				exportDialog:false,
				exportContent:'是否需要导出选中数据,是请选中?',
				newUserDialog:false,
				petListDialog:false,
				checkedList :[],
				params_data:{}
			}
		},
		created() {
			const { page, user_search,user_group_id } = this.$route.query;
			if (page) {
				this.tableForm.page = page;
			}
			if (user_search) {
				this.user_search = user_search;
			}
			if(user_group_id){
				this.user_group_id = user_group_id
			}
			this.initData();
			this.getUserGroupList();
		},
		computed:{
			isShowDel(){
				return (row) => {
					return (row.available_balance > 0 || row.count_amount > 0) ? false : true;
				}
			}
		},
		methods:{
            selectGroupItem(item){
                this.user_group_id = item.group_id;
                this.initData();
			},
		    getUserGroupList(){
                const params = {
                    method : 'com.get.merchant_user.group.list',
                    x_account_type: 'merchant',
                    data:{
                        is_get_user_count: 1,
                    }
                }
                this.$ajax(params).then(res => {
                    if(res.status === 10000){
                        var tempList = [{
                            group_id:'0',
							group_name:'全部'
						}];
                        res.data.list.forEach((temp)=>{
                            tempList.push({
                                group_id:temp.group_id,
                                group_name:temp.group_name,
                            });
                        });
                        this.userGroupList = tempList;
                    }else{
                        this.$message.error(res.info);
                    }
                });
			},
            sortChange(column){
				let sort = {}
				switch (column.order){
					case 'ascending':
					    sort['orderBy'] = 'asc';
					    break;
					case 'descending':
					    sort['orderBy'] = 'desc';
					    break;
					default:
						this.$delete(this.params_data,'orderBy')
						this.$delete(this.params_data,'orderByField')
						break
				}
				if(sort['orderBy']){
					switch (column.prop){
						case 'updated_at':
						    sort['orderByField'] = 'updated_at';
						    break;
						case 'integral':
						    sort['orderByField'] = 'integral';
						    break;
						case 'available_balance':
						    sort['orderByField'] = 'available_balance';
						    break;
						case 'count_amount':
						    sort['orderByField'] = 'count_amount';
						    break;
						default:
							sort = {}
							break
					}
				}
				Object.assign(this.params_data,sort);
				this.initData()

			},
			initData() {
				this.loading = true;
				const params_data = {
				    page: this.tableForm.page,
				    user_search : this.user_search,
				    user_group_id:this.user_group_id,
				};
				console.log(params_data);
				this.$router.replace({ path: '/user/list', query: params_data});
				
				Object.assign(this.params_data,params_data);
				this.$ajax({
					method : 'com.get.merchant.user.list',
					data: this.params_data
				}).then(res => {
					console.log(res);
					if (res.status == 10000) {
						this.tableData = res.data.list;
						this.tableForm.total = res.data.count;
					}
					this.loading = false;
				})
			},
			//跳转到商户详情
			userInfo(uid){
				this.$router.push({name:'会员详情',params:{id:uid}});
			},
			userDel(uid){
				this.$confirm('此操作将永久删除, 是否继续?', '提示', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  type: 'warning'
				}).then(() => {
					const params = {
						method :'com.set.merchant.user.del',
						data:{
							user_id: uid,
						}
					}
					this.loading = true;
					this.$ajax(params).then(res => {
						this.loading = false;
						if (res.status === 10000) {
							this.initData();
							this.$message.success(res.info);
						} else {
							this.$message.error(res.info);
						}
						
					})
				}).catch(() => {});
			},
			//宠物档案
			petDataList(uid){
				this.current_uid = uid;
				this.petListDialog = true;
			},
			//宠物档案回调
			petListTap(val){
				this.petListDialog = val;
			},
			//新增会员回调
			addUserTap(val, type){
				type == 'save' ? this.initData() : '';
				this.newUserDialog = val;
			},
			//新增会员
			newUser(){
				this.newUserDialog = true;
			},
			checkedListChange(val){
			},
		    //导出
			exportData(){
				this.exportDialog = true;
			},
			//导出回调
			popCloseTap(val,type){
				if(type == '2'){

				}
				this.exportDialog = val;
			},
			//根据会员手机号查询
			searchUser(){
				this.tableForm.page = 1;
				this.initData();
			},
		}
	}
</script>

<style scoped>
	.pa_btn{min-width:110px;font-size:12px;}
	.pa_btn.on{background:#FF700B;color:#fff;}

	.pa_user_list_info_box{display:flex;}
	.pa_user_list_info_box .img{overflow:hidden;display:block;width:50px;height:50px;border-radius:50%;}
	.pa_user_list_info_box .text{margin-left:5px;}
	.pa_user_list_info_box .text span{display:block;}
	.pa_user_list_info_box .text .numbers{font-size:12px;}
</style>



// WEBPACK FOOTER //
// user.vue?eadf4d08